import React from 'react';
import { FaTrashAlt, FaPenSquare, FaMoneyBill } from 'react-icons/fa';
import {
  EditButton,
  DeleteButton,
  ViewPaymentsButton,
} from '../styles/ComponentStyles';
import {
  BillsTableWrapper,
  BillsTableEl,
  BillsTableHeader,
  BillsTableRow,
  BillsTableData,
  TypeBadge,
  StatusBadgeBills,
  MonthsData,
} from '../styles/BillsTableStyles';
import PaginationControl from './PaginationControl';

const SubscriptionsTable = ({
  subscriptions = [],
  loading,
  error,
  handleFlashMessage,
  handleDelete,
  currentPage,
  currentPageLimit = 100,
  totalPages = 1,
  onPageChange,
  onPageLimitChange,
  onEdit,
  onViewPayments,
}) => {

  const getStatusColor = (status) => {
    if (status === 'closed') return '#757575';
    return '#4CAF50';
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error loading subscriptions.</div>;

  return (
    <BillsTableWrapper>
      <h2>Subscriptions & Installments</h2>
      <BillsTableEl>
        <thead>
          <tr>
            <BillsTableHeader>Name</BillsTableHeader>
            <BillsTableHeader>Biller</BillsTableHeader>
            <BillsTableHeader>Type</BillsTableHeader>
            <BillsTableHeader>Amount</BillsTableHeader>
            <BillsTableHeader>Status</BillsTableHeader>
            <BillsTableHeader>Months Paid</BillsTableHeader>
            <BillsTableHeader>Months Left</BillsTableHeader>
            <BillsTableHeader>Platform</BillsTableHeader>
            <BillsTableHeader>Payments</BillsTableHeader>
            <BillsTableHeader>Remarks</BillsTableHeader>
            <BillsTableHeader>Actions</BillsTableHeader>
          </tr>
        </thead>
        <tbody>
          {subscriptions.map((sub) => (
            <BillsTableRow key={sub._id}>
              <BillsTableData>{sub.name || '—'}</BillsTableData>
              <BillsTableData>{sub.biller}</BillsTableData>
              <BillsTableData>
                <TypeBadge $variant={sub.recurring_type || 'subscription'}>
                  {sub.recurring_type === 'installment' ? 'Installment' : 'Subscription'}
                </TypeBadge>
              </BillsTableData>
              <BillsTableData>{sub.amount}</BillsTableData>
              <BillsTableData>
                <StatusBadgeBills $color={getStatusColor(sub.status)}>
                  {(sub.status || 'active').toUpperCase()}
                </StatusBadgeBills>
              </BillsTableData>
              <BillsTableData>
                <MonthsData $highlight={sub.months_paid != null && sub.months_paid > 0}>
                  {sub.months_paid != null ? sub.months_paid : '—'}
                </MonthsData>
              </BillsTableData>
              <BillsTableData>
                <MonthsData $highlight={sub.months_left === 0}>
                  {sub.months_left != null ? sub.months_left : '—'}
                </MonthsData>
              </BillsTableData>
              <BillsTableData>{sub.platform}</BillsTableData>
              <BillsTableData>{sub.count_of_payments ?? 0}</BillsTableData>
              <BillsTableData>{sub.remarks}</BillsTableData>
              <BillsTableData>
                {onViewPayments && (
                  <ViewPaymentsButton onClick={() => onViewPayments(sub)} title="Payments">
                    <FaMoneyBill />
                  </ViewPaymentsButton>
                )}
                <EditButton onClick={() => onEdit(sub)} title="Edit">
                  <FaPenSquare />
                </EditButton>
                <DeleteButton onClick={() => handleDelete(sub._id)} title="Delete">
                  <FaTrashAlt />
                </DeleteButton>
              </BillsTableData>
            </BillsTableRow>
          ))}
        </tbody>
      </BillsTableEl>

      <PaginationControl
        currentPage={currentPage}
        currentPageLimit={currentPageLimit}
        totalPages={totalPages}
        handlePageChange={onPageChange}
        handlePageLimitChange={onPageLimitChange}
      />
    </BillsTableWrapper>
  );
};

export default SubscriptionsTable;
